module.exports = "/images/om.svg?239cf3072e3ff84a9a1a283a604f2b6e";